import { Avatar, Button, Divider, Typography } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import Footer from "~/components/common/footerContainer/FooterContainer";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import businessService from "~/services/businessService";
import bookingTransactionService from "~/services/bookingTransactionService";

import useStyles from "./style";
import Utils from "../../helpers/Utils";
import { handleAddress, getInitials, getAvatarFontSize, formatPhoneNumber } from "~/utils/business";
import PaymentSummary from "../common/paymentSummary";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";

const PackagePurchaseConfirmation = (props) => {
	let { business } = useSelector((store) => store.business);
	const [payload, setPayload] = useState(props?.location?.state?.payload);
	const me = Utils.safeParseJSON("@prit-web/meData");

	// Dados do checkout passados via props
	const checkoutInformation = props?.location?.state?.checkout;
	const couponValue = props?.location?.state?.couponValue;
	const totalPricingType = props?.location?.state?.totalPricingType;
	const currency = business?.currency;
	const infoPackage = props?.location?.state?.infoPackage;

	const { id, bookingTransactionId } = useParams();

	const payment_intent = new URLSearchParams(props.location?.search).get("payment_intent");
	const payment_intent_client_secret = new URLSearchParams(props.location?.search).get("payment_intent_client_secret");
	const redirect_status = new URLSearchParams(props.location?.search).get("redirect_status");

	const isForeignCheckout = payment_intent && payment_intent_client_secret && redirect_status;

	const classes = useStyles({ me });
	const { t, i18n } = useTranslation();

	const getServiceName = (item) => {
		if (i18n.language === "en-US") {
			return item.nameEng;
		} else if (i18n.language === "es-ES") {
			return item.nameEsp;
		} else {
			return item.name;
		}
	};

	const getBusiness = async () => {
		await businessService.getBusiness(id).then(({ data }) => {
			business = data;
		});
	};

	const getBookingTransaction = async () => {
		await bookingTransactionService.getOneBookingTransaction(bookingTransactionId).then((res) => {
			const booking = res.data.bookings[0];
			const service = booking.service;
			const services = [
				{
					dateStart: booking.startTime,
					service: getServiceName(service),
				},
			];
			setPayload({
				services: services,
			});
		});
	};

	const checkoutPayload = localStorage.getItem("@prit-web/checkoutPayload");

	if (checkoutPayload) {
		localStorage.removeItem("@prit-web/checkoutPayload");
	}

	useEffect(() => {
		window.scrollTo(0, 0);
		if (isForeignCheckout) {
			if (_.isUndefined(business)) {
				getBusiness();
			}

			if (_.isUndefined(payload)) {
				getBookingTransaction();
			}
		}
	}, []);

	const handleViewReservations = () => {
		props.history.push(`/reservas/${business?.id}`, { view: "packages" });
	};

	// Dados do pacote baseados no infoPackage
	const packageData = {
		name: infoPackage?.info?.packageName || "Pacote de serviços",
		serviceName: infoPackage?.info?.serviceName || "Serviço",
		quantity: infoPackage?.info?.quantity,
		duration: infoPackage?.info?.duration,
		value: Utils.getPostPrice(infoPackage?.body?.bookings[0]?.price * infoPackage?.info?.quantity, currency),
		businessName: business?.name || "Estabelecimento",
	};

	const handleViewOnMap = () => {
		if (business?.address?.latitude && business?.address?.longitude) {
			const url = `https://www.google.com/maps?q=${business.address.latitude},${business.address.longitude}`;
			window.open(url, "_blank");
		} else if (business?.address?.street) {
			const { street, number, unit, postalCode } = business?.address;
			const address = [street, number, postalCode]
				.filter((part) => part != null && String(part).trim() !== "")
				.join(", ");
			const encodedAddress = encodeURIComponent(address);
			const url = `https://www.google.com/maps/search/${encodedAddress}`;
			window.open(url, "_blank");
		}
	};

	const sanitizePhone = (phone) => {
		if (!phone) return "";
		return String(phone).replace(/[^\d+]/g, "");
	};

	const handleCopyPhone = async () => {
		const phone = sanitizePhone(business?.phone);
		if (!phone) return;
		try {
			await navigator.clipboard.writeText(phone);
		} catch (e) {
			console.error("Failed to copy phone", e);
		}
	};

	return (
		<>
			<TitleContainer>
				{/* Seção escura no topo com ícone de sucesso */}
				<div className={classes.successHeader}>
					<div className={classes.successIconContainer}>
						<Check className={classes.successIcon} />
					</div>
					<Typography className={classes.successTitle}>{t("Purchase confirmed")}</Typography>
				</div>
				<div className={classes.headerBusinessBar}>
					<div style={{ minHeight: business?.address?.street ? 80 : 50 }}>
						<Avatar
							variant="circle"
							src={business?.thumbnailUrl ? business.thumbnailUrl : ""}
							className={classes.headerAvatar}>
							<Typography style={{ fontSize: getAvatarFontSize(business?.name) }}>
								{getInitials(business?.name)}
							</Typography>
						</Avatar>
					</div>
					<div className={classes.headerTexts} style={{ minHeight: business?.address?.street ? 80 : 50 }}>
						<Typography className={classes.headerName}>{business?.name}</Typography>
						{business?.address?.street && (
							<div style={{ display: "flex", alignItems: "center" }}>
								<Typography onClick={handleViewOnMap} className={classes.headerInfoUnderlined}>
									{handleAddress(business, 50)}
								</Typography>
							</div>
						)}
						{business?.phone && (
							<div style={{ display: "flex", alignItems: "center" }}>
								<Typography onClick={handleCopyPhone} className={classes.headerInfo} style={{ cursor: "pointer" }}>
									{formatPhoneNumber(business.phone)}
								</Typography>
							</div>
						)}
					</div>
				</div>
				<Divider />
				<div style={{ marginTop: 15 }}>
					<div className={classes.packageInfo}>
						<Typography className={classes.packageLabel}>{t("Service purchased")}:</Typography>
						<Typography className={classes.packageName}>{packageData.name}</Typography>
						<Typography className={classes.serviceName}>
							{`${packageData.serviceName} - ${packageData.quantity} ${
								packageData.quantity > 1 ? t("sessions") : t("session")
							} (${packageData.duration}min)`}
						</Typography>
						<Typography className={classes.packageValue}>
							{t("Value")} {packageData.value}
						</Typography>
					</div>

					{/* Texto informativo */}
					<div className={classes.infoText}>
						<Typography className={classes.infoLine}>{t("Your package is now available in reservations")}</Typography>
						<Typography className={classes.infoLine}>{t("Schedule your session whenever you want")}</Typography>
					</div>

					{/* Botão de ação */}
					<Button onClick={handleViewReservations} className={classes.actionButton} variant="contained">
						{t("View my reservations")}
					</Button>
				</div>
			</TitleContainer>
		</>
	);
};

export default withRouter(PackagePurchaseConfirmation);
